import { Component,Input, OnInit } from '@angular/core';
import { SharedHttpService } from '../../services/shared-http.service';
import { CaseService } from '../../services/case.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {
  showTableView:boolean=true;
  @Input() loadDataFP: Observable<any>;

  constructor(public caseService: CaseService, public sharedService: SharedHttpService) { }
  

  caseObject: any;
  timelineList: any = [];
  ngOnInit(): void {
    this.loadData();
    // this.loadDataFP.subscribe((data) => {
    //   setTimeout(() => {
    //     this.loadData();
    //   }, 100);
    // }); 
  }
  loadData() {
    this.caseObject = this.caseService.getCaseData();
    console.log(this.caseObject, "caseeoff");
    this.sharedService.get(`api/Case/GetVTimeline?eCaseId=${this.caseObject.eCaseId}`).subscribe(res => {
      this.timelineList = res;
      console.log(this.timelineList,);
    });
  }
  
  downloadFile(data: any, item: any) {
    var blob = new Blob([data], { type: item.fileType });
    var url = window.URL.createObjectURL(blob);

    var fileLink = document.createElement('a');
    fileLink.href = url;
    fileLink.download = item.fileName;
    fileLink.click();
  }


  download(item) {
    this.sharedService.downloadFileGet(`api/Case/DownloadLog?CaseLogId=${item.caseLogId}`).subscribe(data => {
      this.downloadFile(data, item);

    });
  }


}
